/* eslint-disable */
export default {
  title: '通过语音消息回复',
  customMessage: '自定义消息',
  customMessagePlaceholder: '输入自定义消息',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
